var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazonReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.amazon-reviews{fill:url(#amazon-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "amazon-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fef18b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32363,
    stopColor: "#fece3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#febc10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f77e1d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "amazon-reviews",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M61.1005,33.5757l-18.48678,10.67346,6.79386,3.92232c.36644.21156.8179.21156,1.18434,0l16.11838-9.30558c.7896-.45586.78961-1.59554.00002-2.0514l-5.60981-3.23881Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M38.42148,41.8288l18.4871-10.67333-6.3164-3.64674c-.36645-.21157-.81792-.21156-1.18437,0l-16.11822,9.30586c-.78959.45587-.78958,1.59554.00001,2.0514l5.13187,2.96282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M47.32819,51.8119l-6.87174-3.96749v9.87964l-4.19211-2.17681v-10.1232l-5.12063-2.95643c-.76735-.44303-1.72654.11075-1.72654.99681v18.68835c0,.41122.21938.7912.57551.99681l16.18448,9.34412c.76735.44303,1.72653-.11076,1.72653-.99681v-18.68818c0-.41122-.21938-.7912-.5755-.99681Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M68.85632,42.46753l-16.185,9.34436c-.35614.20563-.5755.58563-.5755.99683v18.68848c0,.88605.95917,1.43988,1.7265.99683l16.185-9.34442c.35614-.20563.5755-.58563.5755-.99683v-18.68842c0-.88605-.95917-1.43988-1.7265-.99683ZM67.74933,53.20032l-2.18781,3.91858.37628,3.37225c.1076.96429-.82928,2.26758-1.66754,2.31946l-2.93097.18127-2.93091,3.20154c-.83826.91553-1.77515.69366-1.66754-.3949l.37628-3.80658-2.18781-1.39349c-.62561-.3985-.2677-1.83893.63696-2.5636l3.16357-2.53381,1.57892-4.06281c.45148-1.16187,1.60962-1.8302,2.0611-1.18945l1.57892,2.24054,3.16351-1.11743c.90472-.31952,1.26263.70782.63702,1.82843Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonReviewsScraper);
export default __webpack_public_path__ + "static/media/amazon-reviews-scraper.374c05d3c7e1102b6fd1996fe4e4189d.svg";
export { ForwardRef as ReactComponent };